/**
 * Bookmark-specific database operations
 */

/**
 * Save bookmarks from offline data
 * @param {EduQuizDB} db - Database instance
 * @param {Array} resources - Resources array
 * @param {string} BOOKMARK - Resource type constant
 */
export async function saveBookmarks(db, resources, BOOKMARK) {
    const bookmarksData = [];

    for (const resource of resources) {
        if (resource.type === BOOKMARK) {
            // Save bookmark
            bookmarksData.push({
                serverResourceId: resource.id,
                name: resource.name,
                type: resource.type,
                description: resource.description || null,
                url: resource.url,
                thumbnailUrl: resource.thumbnail_url || null,
            });
        }
    }

    if (bookmarksData.length > 0) {
        console.log("Saving bookmarks:", bookmarksData);
        await db.bookmarks.bulkAdd(bookmarksData);
    }
}

/**
 * Get a bookmark by server resource ID
 * @param {EduQuizDB} db - Database instance
 * @param {number} serverResourceId - Server resource ID
 */
export async function getBookmark(db, serverResourceId) {
    try {
        return await db.bookmarks
            .where("serverResourceId")
            .equals(serverResourceId)
            .first();
    } catch (error) {
        console.error("Failed to get bookmark:", error);
        throw error;
    }
}
